import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IconDimensions from 'components/icons/IconDimensions';
import { colorGrayLight2 } from 'styles/layout/colors';
const PDPMobileDimensionsIcon = t0 => {
  const $ = _c(3);
  const {
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconDimensions width={16} height={16} color={colorGrayLight2} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onClick) {
    t2 = <button type="button" className="items-center bg-white border border-solid border-gray-light7 rounded-[40px] text-white flex justify-center h-10 w-10 hover:cursor-pointer" onClick={onClick}>{t1}</button>;
    $[1] = onClick;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
PDPMobileDimensionsIcon.propTypes = {
  onClick: PropTypes.func.isRequired
};
export default PDPMobileDimensionsIcon;